export default __webpack_public_path__ + "static/media/Forward.01c7fd21.svg";